import Icon from '@ant-design/icons';
import React from 'react';

const Sora2Svg: React.FC = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M12 3.8c4.4 0 8 3.6 8 8 0 4.4-3.6 8-8 8-4.4 0-8-3.6-8-8 0-4.4 3.6-8 8-8Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      opacity="0.75"
    />
    <path
      d="M7.2 12.2c2.2-3.8 7.4-4.6 9.6-1.6 1.2 1.7.9 3.9-.6 5.2-1.6 1.4-4 1.4-5.8.2"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.1 7.1h.01M14.9 16.9h.01"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      opacity="0.9"
    />
  </svg>
);

export const Sora2Icon: React.FC<{ className?: string }> = ({ className }) => {
  return <Icon component={Sora2Svg} className={className} />;
};

